export const isOfSanityPostType = (obj: unknown): obj is GatsbyTypes.PostDetailsQueryQuery => {
  if (typeof obj !== 'object' || !obj) {
    return false;
  }

  return Object.keys(obj).some((key) => key === 'sanityPost');
};
